import { useQuery } from "react-query";

import axios from "axios";

import { USER_COLUMN_RS_ENDPOINT } from "api/data";

export async function fetchGeomBinGroupOrder(isOrg: boolean, projectId?: string) {
  try {
    let url = `${USER_COLUMN_RS_ENDPOINT}/geombin/groupOrder/?isOrg=${
      isOrg ? "true" : "false"
    }`;
    if (projectId) {
      url += `&projectId=${projectId}`;
    }
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    throw new Error("Unable to fetch geom bin group order");
  }
}

interface UseGeomBinGroupOrderQueryParamsT {
  isOrg: boolean;
  projectId?: string;
  onError?: (error) => void;
  onSuccess?: (data) => void;
  isAutoRefetching?: boolean;
}

interface UseGeomBinGroupOrderQueryReturnT {
  data;
  error;
  isError: boolean;
  isIdle: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  refetch: () => void;
}

export function useGeomBinGroupOrderQuery(
  params: UseGeomBinGroupOrderQueryParamsT
): UseGeomBinGroupOrderQueryReturnT {
  const { onError, onSuccess, isAutoRefetching = true, isOrg, projectId } = params;

  const queryInfo = useQuery({
    queryKey: ["geomBinGroupOrder", isOrg, projectId],
    queryFn: () => fetchGeomBinGroupOrder(isOrg, projectId),
    onError: (error) => {
      onError && onError(error);
    },
    onSuccess: (data) => {
      onSuccess && onSuccess(data);
    },
    enabled: isAutoRefetching
  });

  return {
    data: queryInfo.data || [],
    error: queryInfo.error,
    isError: queryInfo.status === "error",
    isIdle: queryInfo.status === "idle",
    isLoading: queryInfo.status === "loading",
    isSuccess: queryInfo.status === "success",
    refetch: queryInfo.refetch
  };
}
